// client/src/hooks/useAccounts.js

import { useState, useCallback } from 'react';
import accountService from '../services/accountService';

const useAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState({
    accounts: false,
    createAccount: false,
    balanceHistory: false
  });
  const fetchAccounts = useCallback(async () => {
    setLoading((prev) => ({ ...prev, accounts: true }));
    try {
      const data = await accountService.getAccounts();
      setAccounts(data);
      return data;
    } finally {
      setLoading((prev) => ({ ...prev, accounts: false }));
    }
  }, []);

  const createAccount = useCallback(async (accountData) => {
    setLoading((prev) => ({ ...prev, createAccount: true }));
    try {
      return await accountService.createAccount(accountData);
    } finally {
      setLoading((prev) => ({ ...prev, createAccount: false }));
    }
  }, []);

  const [lastImport, setLastImport] = useState(null);

  const fetchLastImport = useCallback(async () => {
    setLoading((prev) => ({ ...prev, lastImport: true }));
    try {
      const data = await accountService.getLastImport();
      setLastImport(data);
      return data;
    } catch (err) {
      // best-effort : le tableau du dernier import ne bloque pas la page
      setLastImport({ importedAt: null, transactions: [] });
      return null;
    } finally {
      setLoading((prev) => ({ ...prev, lastImport: false }));
    }
  }, []);

  const fetchBalanceHistory = useCallback(async (accountId, range = {}) => {
    setLoading((prev) => ({ ...prev, balanceHistory: true }));
    try {
      return await accountService.getBalanceHistory(accountId, range);
    } finally {
      setLoading((prev) => ({ ...prev, balanceHistory: false }));
    }
  }, []);

  return {
    accounts,
    lastImport,
    loading,
    fetchAccounts,
    fetchLastImport,
    createAccount,
    fetchBalanceHistory
  };
};

export default useAccounts;
